import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

interface WindowSize {
  width: number;
  height: number;
}
export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: 0,
    height: 0,
  });
  const handleSize = useCallback(() => {
    setWindowSize((prev) => ({
      ...prev,
      width: window.innerWidth,
      height: window.innerHeight,
    }));
  }, []);

  useLayoutEffect(() => {
    handleSize();
  }, [handleSize]);

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => {
      window.removeEventListener('resize', handleSize);
    };
  }, [handleSize]);

  return windowSize;
}
